<!-- 处理消息中的链接。因为a链接在小程序中的特殊性，这里使用text代替，点击行为通过事件处理 -->
<template>
  <span class="msg-link" :class="disabled? 'disabled' : ''"
    @click="onClick">{{link.text}}</span>
</template>

<script>
import { handleLinkClick } from '@/utils/bindlLinkClick.js';
export default {
  name: 'message-link',
  props: {
    link: {
      type: Object,
      default() {
        return {
        };
      },
    },
  },
  data() {
    return {
      disabled: false,
    };
  },
  methods: {
    onClick() {
      if (this.disabled) return;
      console.log('[im-message-link]', this.link);

      const { url } = this.link;
      handleLinkClick(url);
      // qdweb链接点击后disabled，除非标记了可以再次点击。
      // if (this.isQDWebLink(url) && !this.link.canClickAgain) {
      //   this.disabled = true;
      // }

      this.$emit('click', url);
    },
  },
};
</script>

<style lang="less" scoped>
    // 此处统一维护消息中的链接样式
    .msg-link{
      word-break: break-word;
      word-wrap: break-word;
      white-space: pre-wrap;
      padding: 0 2px;
      text-decoration:  none;
      cursor: pointer;
      &.disabled{
        color: #262d3d;
        pointer-events: none;
      }
    }
</style>
